import React from 'react'
import ContactForm from './contactForm'
import CheckmarkDisplayIcon from '../images/checkmark-in-display.inline.svg'
import Phone24Icon from '../images/phone-24.inline.svg'
import Since1990Icon from '../images/since-1990.inline.svg'

const Features = () => {
  return (
    <div className='container-fluid three_icon'>
      <div className='sa-icnInfo'>
        <div className='row' style={{ marginBottom: '20px' }}>
          <div className='col-sm-4 col-xs-4'>
            <CheckmarkDisplayIcon />
            <h2>Easier Than Ever Booking</h2>
          </div>
          <div className='col-sm-4 col-xs-4'>
            <Phone24Icon />
            <h2>Available 24x7x365</h2>
          </div>
          <div className='col-sm-4 col-xs-4'>
            <Since1990Icon />
            <h2>Flight Expert Since 2012</h2>
          </div>
        </div>
      </div>
      <ContactForm />
    </div>
  )
}

export default Features
